import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';

// MUI compares these exact ASCII outputs when detecting leading zeros in year tokens.
const MUI_YEAR_FORMAT_CHECK_VALUES = new Set(['0001', '01']);

/** Jalali adapter that displays dates in Persian digits without breaking MUI field logic. */
export class PersianAdapterDateFnsJalali extends AdapterDateFnsJalali {
  constructor(options?: ConstructorParameters<typeof AdapterDateFnsJalali>[0]) {
    super(options);
    const baseFormatByString = this.formatByString;
    this.formatByString = (value: Date, formatString: string) => {
      const result = baseFormatByString(value, formatString);
      if (MUI_YEAR_FORMAT_CHECK_VALUES.has(result)) {
        return result;
      }
      return this.formatNumber(result);
    };
  }
}
